import { QuestionIds } from './QuestionsIds';

export const QuestionsOrder: QuestionIds[] = [
  QuestionIds.Welcome,
  QuestionIds.Reason,
  QuestionIds.HowLikely,
  QuestionIds.Offer,
  QuestionIds.FinishWinBack,
];
